<p style="text-align: center; font-weight: bold;">Recherche de musiques à importer (téléchargements terminés : {{ downloadsOK.length }}/{{ downloadsOK.length + downloadsWaiting.length + (this.isDownloading.length > 0 ? 1 : 0) }})</p>

<div class="recherche-musique">
  <form class="search-form">
    <mat-form-field class="search-full-width">
      <mat-label>Recherche musique, lien playlist, lien album ou lien track</mat-label>
      <input #searchInput matInput placeholder="Recherche musique, lien playlist, lien album ou lien track" value="" (keydown.enter)="searchDeezerEnter($event, searchInput.value)" >
      <button mat-button *ngIf="searchInput.value" matSuffix aria-label="Clear" (click)="searchInput.value=''">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-form-field>
  </form>
  <button color="primary" class="search-full-width-button" mat-flat-button (click)="searchDeezer(searchInput.value)">Recherche musique</button>
</div>

<mat-progress-bar *ngIf="loadingDeezer" style="position: absolute; left: 0; top: 0;" mode="indeterminate"></mat-progress-bar>

<div class="searchResults">

  <span class="titleSearch" *ngIf="tooltipTitleDeezer === ''">{{ titleDeezer }}</span>
  <span class="titleSearch" *ngIf="tooltipTitleDeezer !== ''" matTooltip="{{tooltipTitleDeezer}}">{{ titleDeezer }}</span>

  <table mat-table [dataSource]="isClassicSearch ? musiquesDeezer : musiquesMatTable">

    <ng-container matColumnDef="presence">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element" style="width: 40px;"
          matTooltip="{{ (element.presence && element.presence.count && element.presence.count > 0) ?
          'Il y a déjà ' + element.presence.count + ' version' + (element.presence.count > 1 ? 's' : '') + ' correspondant à ce titre ==> ' + element.presence.versionsConcat :
          'Pas de correspondance trouvée pour ce titre'}}">
        <span matBadge="{{ (element.presence && element.presence.count) ? element.presence.count : 0 }}"
              class="{{ (element.presence && element.presence.count && element.presence.count > 0) ? 'mat-green' : '' }}"
              style="width: 20px; height: 20px; vertical-align: middle; position: relative;">

        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="cover">
      <th mat-header-cell *matHeaderCellDef> Cover </th>
      <td mat-cell *matCellDef="let element">
        <div class="imgContainer">
          <img src="{{ element.album.cover ? element.album.cover : 'assets/img/defLoad.png' }}">
          <div *ngIf="element.preview !== searchMusicsService.audioPlaying" (click)="playExtraitAndReleaseDate(element)" class="iconPlayer">
            <mat-icon svgIcon="play"></mat-icon>
          </div>
          <div *ngIf="element.preview === searchMusicsService.audioPlaying" (click)="searchMusicsService.stopextrait()" class="iconPlayer">
            <mat-icon svgIcon="stop"></mat-icon>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="release">
      <th mat-header-cell *matHeaderCellDef> Release </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.album_extend && element.album_extend.release_date" matTooltip="{{element.album_extend.label}}">
          {{element.album_extend.release_date}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef> Titre </th>
      <td mat-cell *matCellDef="let element"> {{element.title_short}} </td>
    </ng-container>

    <ng-container matColumnDef="artist">
      <th mat-header-cell *matHeaderCellDef> Artiste </th>
      <td mat-cell *matCellDef="let element"> {{element.artist.name}} </td>
    </ng-container>

    <ng-container matColumnDef="album">
      <th mat-header-cell *matHeaderCellDef> Album </th>
      <td mat-cell *matCellDef="let element"> <span (click)="searchPlaylistDeezer(element.album.id, 1)" style="cursor: pointer; text-decoration: underline; font-style: italic;"
                                                    matTooltip="Rechercher les titres de l'album « {{element.album.title}} »">{{element.album.title}}</span> </td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef> Durée </th>
      <td mat-cell *matCellDef="let element"> {{ element.duration | minutesSeconds }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <!--<button style="float: right; width: 180px;" color="primary" disabled mat-flat-button>Télécharger sélection</button>-->
      </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="(element.link !== isDownloading && !isInWaitingList(element)) && !downloadsOK.includes(element.link)" style="float: right; width: 180px;" color="primary" mat-flat-button (click)="downloadMusic(element)">Télécharger</button>
        <button *ngIf="(element.link === isDownloading || isInWaitingList(element)) && !downloadsOK.includes(element.link)" style="float: right; width: 180px; background-color: #f39c12" color="primary" mat-flat-button>En cours ...</button>
        <button *ngIf="downloadsOK.includes(element.link)" style="float: right; width: 180px; background-color: #27ae60" color="primary" mat-flat-button (click)="downloadAudioFile(element)">Ajouté</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell style="text-align: right" *matHeaderCellDef>
        <!--<mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selectionMusiquesDeezer.hasValue() && isAllSelected()"
                      [indeterminate]="selectionMusiquesDeezer.hasValue() && !isAllSelected()">
        </mat-checkbox>-->
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selectionMusiquesDeezer.hasValue() && isAllSelected()"
                      [indeterminate]="selectionMusiquesDeezer.hasValue() && !isAllSelected()"
                      [disabled]="true">
        </mat-checkbox>
      </th>
      <td mat-cell style="text-align: right" *matCellDef="let element">
        <!--<mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selectionMusiquesDeezer.toggle(element) : null"
                      [checked]="selectionMusiquesDeezer.isSelected(element)"
                      [disabled]="downloadsOK.includes(element.link)" >
        </mat-checkbox>-->
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selectionMusiquesDeezer.toggle(element) : null"
                      [checked]="selectionMusiquesDeezer.isSelected(element)"
                      [disabled]="true" >
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div class="search-spinner-container">
    <mat-progress-spinner *ngIf="loadingDeezer" class="mat-progress-spinner-search" mode="indeterminate"></mat-progress-spinner>
  </div>

  <mat-paginator #PaginatorPlaylists [hidden]="isClassicSearch" [length]="musiquesDeezer.length" [pageSize]="25" [hidePageSize]="true" showFirstLastButtons></mat-paginator>
  <mat-paginator #PaginatorClassic [hidden]="!isClassicSearch" [length]="classicLength" [pageSize]="25"
                 [pageIndex]="classicIndex" [hidePageSize]="true" showFirstLastButtons
                 (page)="changePageClassic($event)"></mat-paginator>

</div>
